<template>
  <div>
    <section class="app-section"
      v-loading.fullscreen="isRequesting"
      element-loading-text="サーバーに問い合わせています">
      <header class="app-header flex justify-between items-center">
        <h2 class="app-h2">固定ページ一覧</h2>
        <el-button @click="dialogAddPageVisible = true">新規作成</el-button>
      </header>

      <template v-if="isInitialized">
        <el-table :data="pages" stripe style="width: 100%">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column label="タイトル" width="240">
            <template slot-scope="scope">
              <div class="flex justify-center items-center">
                <template v-if="scope.row.hierarchy > 0">
                  <span :style="'padding-left:' + scope.row.hierarchy + 'em; width: 4em'">└─</span>
                  <!-- <span :style="'padding-left:' + page.hierarchy + 'em'">└──</span> -->
                  <!-- <span :style="'padding-left:' + page.hierarchy + 'em'">&#8627;</span> -->
                </template>
                <input class="table-input" v-model="scope.row.title.rendered" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="スラッグ" width="160">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.slug" />
            </template>
          </el-table-column>
          <el-table-column label="親ページ" width="160">
            <template slot-scope="scope">
              <el-select class="table-input" v-model="scope.row.parent" placeholder="Select">
                <el-option label="なし" :value="0"></el-option>
                <template v-for="child in pages">
                  <template v-if="child.id !== scope.row.id">
                    <el-option :key="child.id" :label="child.title.rendered" :value="child.id"></el-option>
                  </template>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="メニュー順" width="100">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.menu_order" />
            </template>
          </el-table-column>
          <el-table-column label="状態" width="220">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.status" size="mini">
                <el-radio-button label="publish">公開</el-radio-button>
                <el-radio-button label="private">非公開</el-radio-button>
                <el-radio-button label="draft">下書き</el-radio-button>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="修正日" width="170">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.modified) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="330">
            <template slot-scope="scope">
              <div class="flex items-center">
                <el-tooltip class="item" effect="dark" content="ページを閲覧する" placement="top">
                  <el-button size="small" @click="window.open(scope.row.link)"><i class="fa fa-fw fa-external-link" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="ページをプレビューする" placement="top">
                  <el-button size="small" @click="onPreview(scope.row)"><i class="fa fa-fw fa-desktop" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="ページを更新する" placement="top">
                  <el-button size="small" @click="onUpdate(scope.row)"><i class="fa fa-fw fa-refresh" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="ページを編集する" placement="top">
                  <el-button size="small" @click="onEdit(scope.row)"><i class="fa fa-fw fa-edit" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="ページを削除する" placement="top">
                  <el-button size="small" type="danger" @click="confirmBeforeDelete(scope.row)"><i class="fa fa-fw fa-trash" aria-hidden="true"></i></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>

    </section>

    <el-dialog class="centering" width="90%" title="プレビュー" :visible.sync="previewDialogVisible">
      <iframe :class="['preview-iframe', previewSize]" :src="previewLink"></iframe>
      <span slot="footer" class="preview-footer flex column justify-center items-center row-s justify-between-s">
        <div class="preview-controller flex column justify-center row-s">
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'smartphone'"><i class="fa fa-fw fa-mobile" aria-hidden="true"></i>Smartphone</el-button>
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'tablet'"><i class="fa fa-fw fa-tablet" aria-hidden="true"></i>Tablet</el-button>
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'desktop'"><i class="fa fa-fw fa-desktop" aria-hidden="true"></i>Desktop</el-button>
        </div>
        <el-button class="preview-controller-button" type="primary" @click="previewDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog width="280px" title="確認" :visible.sync="dialogVisible">
      <template v-if="deletingPage">
        <p>{{ deletingPage.title.rendered }}</p>
      </template>
      <p>このページを削除しますか？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">いいえ</el-button>
        <el-button type="primary" @click="deletePost">はい</el-button>
      </span>
    </el-dialog>

    <el-dialog width="50%" top="50px" title="固定ページの新規作成" :visible.sync="dialogAddPageVisible">
      <el-form ref="newPage" :model="newPage" label-position="left" class="padding">
        <el-form-item label="タイトル" prop="title" :rules="[{required: true, message: 'タイトルは必ず入力してください'}]">
          <el-input class="width-100" type="text" v-model.trim="newPage.title" placeholder="（例）選ばれる理由" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="スラッグ（固定ページのURLパス）" prop="slug" :rules="[{required: true, message: 'スラッグは必ず入力してください'}]">
          <el-input class="width-100" type="text" v-model.trim="newPage.slug" placeholder="（例）four-reasons" auto-complete="off"></el-input>
        </el-form-item>
        <div class="padding-top">
          <el-form-item label="親ページ" label-width="90px">
            <el-select v-model="newPage.parent" placeholder="Select">
              <el-option label="なし" :value="0"></el-option>
              <template v-for="child in pages">
                <el-option :key="child.id" :label="child.title.rendered" :value="child.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="メニュー順" label-width="90px">
          <el-input v-model="newPage.menu_order"></el-input>
        </el-form-item>
        <el-form-item label="状態" label-width="90px">
          <el-radio-group v-model="newPage.status" size="mini">
            <el-radio-button label="publish">公開</el-radio-button>
            <el-radio-button label="private">非公開</el-radio-button>
            <el-radio-button label="draft">下書き</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddPageVisible = false">キャンセル</el-button>
        <el-button :disabled="!isFormFilled" type="primary" @click="onCreate(newPage)">作成</el-button>
      </span>
    </el-dialog>

    <el-dialog width="50%" :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RouteBase from '@/components/mixins/RouteBase'
import moment from 'moment'

const NEW_PAGE = {
  title: '',
  slug: '',
  date: new Date(),
  status: 'publish',
  parent: 0,
  menu_order: 0
}

export default {
  name: 'pages',
  mixins: [RouteBase],
  data: function () {
    return {
      window: window,
      dialogVisible: false,
      previewDialogVisible: false,
      dialogAddPageVisible: false,
      deletingPage: null,
      previewLink: null,
      previewSize: 'desktop',
      sort: {
        type: 'menu_order',
        order: 1
      },
      newPage: Object.assign({}, NEW_PAGE)
    }
  },
  computed: {
    isFormFilled: function () {
      return this.newPage.title !== '' && this.newPage.slug !== ''
    }
  },
  methods: {
    /**
     * 固定ページをソート
     */
    sortPages: function (type, order) {
      // if (this.sort.type === type) {
      //   this.sort.order *= -1
      // } else {
      //   this.sort.type = type
      //   this.sort.order = 1
      // }
      // if (type === 'title') {
      //   this.pages.sort((a, b) => a.title.rendered > b.title.rendered ? this.sort.order : -this.sort.order)
      // } else {
      //   this.pages.sort((a, b) => a[this.sort.type] > b[this.sort.type] ? this.sort.order : -this.sort.order)
      // }
    },
    /**
     * momentで日付をフォーマットして表示
     */
    formatDate: function (date) {
      return moment(date).format('YYYY年M月D日k時m分')
    },
    /**
     * 固定ページを新規作成
     */
    onCreate: async function (newPage) {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/pages/create', newPage)
      this.isRequesting = false
      if (response.id) {
        this.$notify({
          title: '作成完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '作成失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
      this.dialogAddPageVisible = false
    },
    /**
     * 固定ページを更新
     */
    onUpdate: async function (page) {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/pages/update', page)
      this.isRequesting = false
      if (response.id === page.id) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    },
    /**
     * 固定ページのコンポーネントを編集
     */
    onEdit: function (page) {
      this.$store.commit('wordpress/pages/select', page.id)
      this.$router.push({name: 'page', params: {id: page.id, page}})
    },
    /**
     * 固定ページのページ内プレビュー
     */
    onPreview: function (page) {
      this.previewLink = page.link
      this.previewDialogVisible = true
    },
    /**
     * 固定ページを削除する前に確認する
     */
    confirmBeforeDelete: async function (page) {
      this.dialogVisible = true
      this.deletingPage = page
    },
    /**
     * 固定ページを削除する
     */
    deletePost: async function () {
      this.dialogVisible = false
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/pages/delete', this.deletingPage.id)
      this.isRequesting = false
      if (response.id === this.deletingPage.id) {
        this.$notify({
          title: '削除完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '削除失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
      this.deletingPage = null
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Pages created...')

    this.isRequesting = true
    try { await this.requestPages() } catch (error) { return false }
    this.isRequesting = false
    this.isInitialized = true
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.preview {
  &-footer {
    & .fa.fa-fw {
      margin-right: .25em;
    }
  }
  &-controller {
    &-button {
      margin: .5em;
    }
  }
  &-iframe {
    display: block;
    margin: auto;
    border: none;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 70vh;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    background-color: #fff;
    &.smartphone {
      width: 320px;
    }
    &.tablet {
      width: 768px;
    }
    &.desktop {
      width: 100%;
    }
  }
}

.table-input {
  display: block;
  padding: .25em .75em;
  border-width: 1px;
  border-color: $--color-primary;
  border-radius: 4px;
  width: 100%;
  min-height: 2.5em;
  outline: none;
  &:focus {
    border-style: solid;
    background-color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/routes/Pages.vue